import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StepTile } from '@tran-monorepo/interfaces';
import { StepTileComponent } from './step-tile/step-tile.component';

@Component({
    selector: 'tran-steps',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [StepTileComponent],
    templateUrl: './steps.component.html'
})
export class StepsComponent {
    public readonly steps = input.required<StepTile[]>();
    public readonly stepPrefix = input<string>('components.step-section.step');
}
